import type { Dialogues } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

export const useFetchCustomFollowUpContext = (
	fetchContext?: () => Promise<Dialogues[]>,
): {
	getCustomFollowUpContext: () => Promise<Dialogues[] | undefined>;
} => {
	const getCustomFollowUpContext = async (): Promise<Dialogues[] | undefined> => {
		if (fetchContext) {
			try {
				const customFollowUpContext = (await fetchContext()) ?? [];
				return customFollowUpContext;
			} catch {
				return [];
			}
		}
	};
	return {
		getCustomFollowUpContext,
	};
};
